module.exports = __webpack_public_path__ + "img/1.681de5cc.png";